<template>
    <InertiaLink class="text-secondary border-b border-indigo-700 border-dashed hover:text-indigo-900 hover:border-indigo-900 transition-all">
        <slot />
    </InertiaLink>
</template>
